import { writable } from "svelte/store";

const DownloadsStore = writable([
    {
        id: "WQnhY",
        title: "Graph To Matrix - TSPQ",
        desc: "A helper program to visually design graphs on a canvas and export their Hamiltonian with one click as an input for the quantum annealers",
        fsize: "8.7 MB",
        type: "EXE",
        href: "../docs/Graph to Matrix - TSPQ.exe"
    },
    {
        id: "2Jmfy",
        title: "Path Visualizer - TSPQ",
        desc: "A helper program to read and visualize the solutions of quantum annealers to Traveling Salesman Problems on a canvas",
        fsize: "8.7 MB",
        type: "EXE",
        href: "../docs/Path Visualizer - TSPQ.exe"
    },
    {
        id: "APf1g",
        title: "Tutorial notebook",
        desc: "An interactive Python notebook for those who are interested in the code for this course, including tutorials on how to interact with the D-Wave quantum annealers",
        fsize: "1.2 MB",
        type: "IPYNB",
        href: "../docs/Solving the Traveling Salesman Problem with quantum annealers.ipynb"
    },
    {
        id: "HQerk",
        title: "Experimental results database",
        desc: "This file contains the raw data of the measurements made to evaluate the performance of the TSP quantum algorithm; useful for plotting your own graphs, can be read by various JSON libraries",
        fsize: "44.3 KB",
        type: "JSON",
        href: "../docs/data.json"
    },
    {
        id: "Pv9Rq",
        title: "Resultsbook",
        desc: "All relevant experimental and benchmarking data, concatenated into a single document; contains the Hamiltonians and data plots for graphs of all solvable sizes, free for print production",
        fsize: "2.5 MB",
        type: "PDF",
        href: "../docs/Resultsbook.pdf"
    },
]);

export default DownloadsStore;